(() => {
  const sections = document.querySelectorAll('[data-revinta-product]');

  sections.forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const product = JSON.parse(root.querySelector('[data-rv-product-json]').textContent);
    const form = root.querySelector('.rv-form');
    const variantInput = root.querySelector('[data-rv-variant-id]');
    const price = root.querySelector('[data-rv-price]');
    const addButton = root.querySelector('[data-rv-add]');
    const formStatus = root.querySelector('[data-rv-form-status]');
    const overlay = root.querySelector('[data-rv-cart-overlay]');
    const cartBody = root.querySelector('[data-rv-cart-body]');
    const cartTotal = root.querySelector('[data-rv-cart-total]');
    const cartCount = root.querySelector('[data-rv-cart-count]');
    const gallery = root.querySelector('[data-rv-gallery]');
    const sideMenu = root.querySelector('[data-rv-side-menu]');
    const menuScrim = root.querySelector('.rv-side-menu-scrim');
    const smsForm = root.querySelector('[data-rv-sms-form]');
    const smsSuccess = root.querySelector('[data-rv-sms-success]');
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    const formatMoney = (cents) => {
      const amount = (cents / 100).toFixed(2);
      const commaAmount = amount.replace('.', ',');
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, commaAmount)
        .replace(/\{\{\s*amount\s*\}\}/, amount);
    };

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
    })[character]);

    const selectedOptions = () => [...root.querySelectorAll('[data-rv-option-group]')].map((group) => {
      return group.querySelector('.is-selected')?.dataset.rvOptionValue;
    });

    const selectedVariant = () => {
      const values = selectedOptions();
      return product.variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    };

    const updateAvailability = () => {
      const current = selectedOptions();
      root.querySelectorAll('[data-rv-option-group]').forEach((group, groupIndex) => {
        group.querySelectorAll('[data-rv-option-value]').forEach((button) => {
          const candidate = [...current];
          candidate[groupIndex] = button.dataset.rvOptionValue;
          const available = product.variants.some((variant) => {
            return variant.available && variant.options.every((value, index) => value === candidate[index]);
          });
          button.classList.toggle('is-sold-out', !available);
          button.setAttribute('aria-label', available ? button.dataset.rvOptionValue : `${button.dataset.rvOptionValue} sold out`);
        });
      });
    };

    const updateVariant = () => {
      const variant = selectedVariant();
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        formStatus.textContent = 'This combination is unavailable.';
        updateAvailability();
        return;
      }
      variantInput.value = variant.id;
      price.textContent = formatMoney(variant.price);
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      formStatus.textContent = variant.available ? '' : 'Selected option is sold out.';
      updateAvailability();
    };

    root.querySelectorAll('[data-rv-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-rv-option-group]');
        group.querySelectorAll('[data-rv-option-value]').forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-selected');
        button.setAttribute('aria-pressed', 'true');
        updateVariant();
      });
    });

    const openCart = () => {
      overlay.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      root.querySelector('[data-rv-close-cart]').focus();
    };

    const closeCart = () => {
      overlay.hidden = true;
      document.documentElement.style.overflow = '';
    };

    const openMenu = () => {
      root.classList.add('is-menu-open');
      sideMenu.setAttribute('aria-hidden', 'false');
      menuScrim.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      root.querySelector('[data-rv-close-menu]').focus();
    };

    const closeMenu = () => {
      root.classList.remove('is-menu-open');
      sideMenu.setAttribute('aria-hidden', 'true');
      menuScrim.hidden = true;
      document.documentElement.style.overflow = '';
    };

    const renderCart = (cart) => {
      cartCount.textContent = cart.item_count;
      cartTotal.textContent = formatMoney(cart.total_price);
      cartBody.innerHTML = cart.items.map((item, index) => `
        <article class="rv-cart-item">
          <div class="rv-cart-item__image">
            ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">` : ''}
          </div>
          <div class="rv-cart-item__controls">
            <button type="button" aria-label="Remove ${escapeHtml(item.product_title)}" data-rv-change-line="${index + 1}" data-rv-quantity="0">
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M9 7V4h6v3m-8 0 1 14h8l1-14M10 11v6m4-6v6"></path></svg>
            </button>
            <span>${item.quantity}</span>
            <button type="button" aria-label="Increase ${escapeHtml(item.product_title)}" data-rv-change-line="${index + 1}" data-rv-quantity="${item.quantity + 1}">+</button>
          </div>
          <div class="rv-cart-item__variant">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : 'One size'}</div>
          <div class="rv-cart-item__meta">
            <span>${escapeHtml(item.product_title)}</span>
            <span>${formatMoney(item.final_line_price)}</span>
          </div>
        </article>
      `).join('');
    };

    const getCart = async () => {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Could not load bag.');
      return response.json();
    };

    const refreshCart = async (shouldOpen = true) => {
      const cart = await getCart();
      renderCart(cart);
      if (shouldOpen) openCart();
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      addButton.disabled = true;
      formStatus.textContent = '';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'Could not add this item.');
        }
        await refreshCart(true);
      } catch (error) {
        formStatus.textContent = error.message;
      } finally {
        updateVariant();
      }
    });

    cartBody.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-rv-change-line]');
      if (!button) return;
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            line: Number(button.dataset.rvChangeLine),
            quantity: Number(button.dataset.rvQuantity)
          })
        });
        if (!response.ok) throw new Error('Could not update bag.');
        renderCart(await response.json());
      } catch (error) {
        formStatus.textContent = error.message;
      }
    });

    root.querySelector('[data-rv-open-cart]').addEventListener('click', async () => {
      try { await refreshCart(true); } catch (error) { formStatus.textContent = error.message; }
    });
    root.querySelector('[data-rv-close-cart]').addEventListener('click', closeCart);
    overlay.addEventListener('click', (event) => { if (event.target === overlay) closeCart(); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (!overlay.hidden) closeCart();
      if (root.classList.contains('is-menu-open')) closeMenu();
    });

    root.querySelector('[data-rv-previous]')?.addEventListener('click', () => {
      gallery.scrollBy({ left: -gallery.clientWidth, behavior: 'smooth' });
    });
    root.querySelector('[data-rv-next]')?.addEventListener('click', () => {
      gallery.scrollBy({ left: gallery.clientWidth, behavior: 'smooth' });
    });

    root.querySelector('[data-rv-menu-trigger]').addEventListener('click', openMenu);
    root.querySelectorAll('[data-rv-close-menu]').forEach((button) => button.addEventListener('click', closeMenu));
    root.querySelector('[data-rv-menu-cart]')?.addEventListener('click', async () => {
      closeMenu();
      try { await refreshCart(true); } catch (error) { formStatus.textContent = error.message; }
    });
    smsForm?.addEventListener('submit', () => {
      smsSuccess.hidden = false;
    });

    updateVariant();
  });
})();
